import React from 'react';
import { FadeIn } from './FadeIn';
export function Divider() {
  return <FadeIn className="flex justify-center items-center py-8" data-id="element-3">
      <div className="w-16 h-[1px] bg-brand-gold/30" data-id="element-4"></div>
      <div className="mx-4 text-brand-gold text-xl" data-id="element-5">✧</div>
      <div className="w-16 h-[1px] bg-brand-gold/30" data-id="element-6"></div>
    </FadeIn>;
}